import React, { useEffect, useState } from "react";
import InfoSection from "../tenantsDetail/info";
import LeaseSection from "../tenantsDetail/leaseSection";
import MaintainanceSection from "../tenantsDetail/maintainance";
import Breadcrumbs from "../../../reusebale/breadcrumbs";
import InfoCards from "../../../reusebale/cards";
import db from "../../../../db/index.json";
import BaseUrl from "../../../../constants/BaseUrl";
import CompanyInfoSection from "./companyInfo";
import { useSelector } from "react-redux";
import TenantLoader from "../../../skeleton-loader/tennant-detail";
import ContactInfo from "./contactInfo";

const MainTenantSection = ({
  onBack,
  seletedTenant,
  onViewMaintainDetails,
  onViewMaintainCreate,
  toggleLeaseDetail,
  toggleCreateLease,
  onTriggerCard,
}) => {
  const { tenants } = db;
  const [tenantProfileInfo, setTenantProfileInfor] = useState();
  const [maintenanceRequest, setMaintenancRequest] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [AllLease, setAllLeases] = useState([]);
  const { loginSuccess } = useSelector((state) => state.auth);
  const [paymentInfo, setPaymentInfo] = useState(null);

  const GetTenantProfileInformation = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}tenant/profile/getProfileDetails/${seletedTenant?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setTenantProfileInfor(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetMaintenanceRequetByTenantId = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/maintenence/getMeintenanceRequestByTenantId/${seletedTenant?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setMaintenancRequest(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetContactByTenant = () => {
    setIsLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/individualContact/getIndividualContacts?tenantId=${seletedTenant?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setIsLoading(false);
        if (result.status === "Success" || result.status === "success") {
          setPaymentInfo(result.data[0]);
        } else {
          console.error("Failed to fetch payment info:", result.message);
          setPaymentInfo(null);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching payment info:", error);
        setPaymentInfo(null);
      });
  };

  const GetAllleasesByLandloardAndTenantId = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/lease/getAllLeaseByTenant/${seletedTenant?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setAllLeases(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        GetTenantProfileInformation(),
        GetMaintenanceRequetByTenantId(),
        GetAllleasesByLandloardAndTenantId(),
        GetContactByTenant(),
      ]);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  //Hassand here you will get all the avilable leases
  // AllLease

  return (
    <div className="mt-6">
      <Breadcrumbs
        classes={`text-darkColor font-popinsSemiBold text-xl`}
        content={`${seletedTenant?.firstName} ${seletedTenant?.lastName}`}
        subheading="Tenant Information"
        onBack={onBack}
      />
      {isLoading && <TenantLoader />}
      {!isLoading && (
        <>
          <div className="flex justify-between">
            <div className="w-[49%]">
              <InfoSection tenantInfo={tenantProfileInfo} />
            </div>
            <div className="w-[49%] h-full">
              <CompanyInfoSection CompanyInfo={tenantProfileInfo} />
            </div>
          </div>
          <div className="w-full mt-3">
            <ContactInfo paymentData={paymentInfo} />
          </div>

          <LeaseSection
            AllLeases={AllLease}
            isViewDetails={toggleLeaseDetail}
          />
          <MaintainanceSection
            maintenanceRequest={maintenanceRequest}
            onViewDetails={onViewMaintainDetails}
          />
          {/* <div className="flex flex-wrap my-5" id="gk-cards">
        {tenants.cardData2.map((item, i) => (
          <InfoCards item={item} classes="mr-[2%]" onTrigger={onTriggerCard} />
        ))}
      </div> */}
        </>
      )}
    </div>
  );
};

export default MainTenantSection;
